import { MfeContainer, IMfeManifest, MfeModule } from '../types'
import { loadModule } from '../../../utils/webpack'

const loadMfeManifest = async (name: MfeContainer): Promise<IMfeManifest> => {
  try {
    const manifest = await loadModule<IMfeManifest>(name, MfeModule.Manifest)
    return { ...manifest, name, loaded: true }
  } catch (err) {
    console.error(`[MFEs] It wasn't possible to load the manifest of '${name}'.`, err)
    return { routes: [], basePath: '', name, loaded: false }
  }
}

export const loadManifests = (): Promise<Array<IMfeManifest>> =>
  Promise.all(Object.values(MfeContainer).map(loadMfeManifest))
